import React, { useMemo } from 'react';

type InformationProps = {
  icon: string;
  alt: string;
  link: string;
  desc: string | Array<string | React.ReactNode>;
  info: Array<string>;
  copy: string;
};

/**
 * @description Footer에 들어가는 회사 정보 컴포넌트
 * @property {string} icon 회사 로고
 * @property {string} alt 로고 이미지 alt 값
 * @property {string} link 로고 이미지 클릭시 이동 경로
 * @property {string | Array<string | React.ReactNode>} desc 회사 설명
 * @property {Array<string>} info 회사 정보
 * @property {string} copy Copy Write
 */
function Information({ icon, alt, link, desc, info, copy }: InformationProps) {
  // 회사 정보 배열 사이에 <br />을 삽입하여 간격을 둠
  const information = useMemo(() => {
    const arr: Array<string | React.ReactNode> = [info[0]];
    for (let i = 1; i < info.length; i += 1) {
      arr.push(<br />, info[i]);
    }
    return arr;
  }, [info]);

  return (
    <div className="information-wrapper wrapper">
      <a id="icon" href={link} target="_blank">
        <img src={icon} alt={alt} />
      </a>
      <p className="text-body" id="description">
        {desc}
      </p>
      <p className="text-info" id="information">
        {information}
      </p>
      <p className="text-caption" id="copywrite">
        {copy}
      </p>
    </div>
  );
}

export default Information;
